import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Send, Mail, Phone, MapPin } from 'lucide-react';
import { getHost } from '../lib/site';
import { TELEGRAM_CHANNEL, TWITTER_URL } from '../lib/socials';

export default function Footer() {
  const host = getHost();
  return (
    <footer className="relative z-10 border-t border-border/60 mt-16">
      <div className="container-x py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img src={(process.env.PUBLIC_URL || '') + '/assets/logo.png'} alt="logo" className="w-10 h-10 object-contain drop-shadow-[0_0_10px_rgba(0,255,102,0.5)]" />
              <span className="font-display font-extrabold text-lg">
                PumpFun <span className="gradient-text">Sniper</span>
              </span>
            </Link>
            <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
              The fastest Solana pump.fun sniper bot. Audited, battle-tested, trusted by 42,000+ traders worldwide.
            </p>
            <div className="flex items-center gap-2 mt-5">
              <a href={TWITTER_URL} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg border border-border/70 flex items-center justify-center text-muted-foreground hover:text-[hsl(var(--primary))] hover:border-[hsl(var(--primary))]/60 transition-colors" aria-label="Twitter">
                <Twitter className="w-4 h-4" />
              </a>
              <a href={TELEGRAM_CHANNEL} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg border border-border/70 flex items-center justify-center text-muted-foreground hover:text-[hsl(var(--primary))] hover:border-[hsl(var(--primary))]/60 transition-colors" aria-label="Telegram" data-testid="footer-telegram">
                <Send className="w-4 h-4" />
              </a>
              <a href={`mailto:hello@${host}`} className="w-9 h-9 rounded-lg border border-border/70 flex items-center justify-center text-muted-foreground hover:text-[hsl(var(--primary))] hover:border-[hsl(var(--primary))]/60 transition-colors" aria-label="Email">
                <Mail className="w-4 h-4" />
              </a>
            </div>
            <div className="mt-5 text-xs text-muted-foreground space-y-1.5">
              <div className="flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5 text-[hsl(var(--primary))] shrink-0" />
                Dubai HQ · Singapore · Lisbon
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-3.5 h-3.5 text-[hsl(var(--primary))] shrink-0" />
                +971 4 580 2847
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5 text-[hsl(var(--primary))] shrink-0" />
                hello@{host}
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-display font-bold text-sm mb-3">Product</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pricing"   className="text-muted-foreground hover:text-foreground">Pricing</Link></li>
              <li><Link to="/developers" className="text-muted-foreground hover:text-foreground">API</Link></li>
              <li><Link to="/docs"      className="text-muted-foreground hover:text-foreground">Docs</Link></li>
              <li><Link to="/source"    className="text-muted-foreground hover:text-foreground">Source Code</Link></li>
              <li><a   href="terminal/" className="text-muted-foreground hover:text-foreground">Terminal</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-sm mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about"    className="text-muted-foreground hover:text-foreground">About</Link></li>
              <li><Link to="/faq"      className="text-muted-foreground hover:text-foreground">FAQ</Link></li>
              <li><Link to="/contact"  className="text-muted-foreground hover:text-foreground">Contact</Link></li>
              <li><Link to="/referral" className="text-muted-foreground hover:text-foreground">Referral</Link></li>
              <li><Link to="/legal"    className="text-muted-foreground hover:text-foreground">Legal</Link></li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-12 pt-6 border-t border-border/60 text-xs font-mono text-muted-foreground">
          <p>© 2026 PumpFun Sniper · {host} · All rights reserved.</p>
          <p>Audited by <span className="text-[hsl(var(--primary))]">CertiK</span> &amp; <span className="text-[hsl(var(--primary))]">OpenZeppelin</span> · Bug bounty <span className="text-[hsl(var(--primary))]">$100K</span></p>
        </div>
      </div>
    </footer>
  );
}
